import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_COMMENT_BY_ID } from 'constants/api';
import { generateURL } from 'helpers';
import { ScorecardsActionStoreArgument } from 'store/interfaces';
import { updateScorecardCommentsThread } from 'store/scorecards';
import { storeName } from '../config';
import { Thread } from '../interfaces';

export const deleteScorecardComment = createAsyncThunk<
  { id: number },
  {
    thread: Thread;
    commentId: number;
    scorecardId: number;
    goalId: number;
    subgoalId?: number;
    store: ScorecardsActionStoreArgument;
  },
  { rejectValue: { id: number } }
>(
  `${storeName}/deleteScorecardComment`,
  ({ thread, commentId, scorecardId, goalId, subgoalId, store }, thunkAPI) =>
    api.axios
      .delete<{ id: number }>(
        generateURL(API_COMMENT_BY_ID, { threadId: thread.id, commentId }),
      )
      .then((res) => {
        thunkAPI.dispatch(
          updateScorecardCommentsThread({
            store,
            scorecardId,
            goalId,
            subgoalId,
            thread: { id: thread.id, totalMessages: 0 },
            change: -1,
          }),
        );
        return res.data;
      })
      .catch(() => thunkAPI.rejectWithValue({ id: commentId })),
);
